import React from 'react'
import {Col, Row} from "antd";

const StageProgressBar = ({
    stages = [],
    activeStage,
    ...props
}) => {
    return(
        <div className={'container-sm'} style={{position:'relative'}}>

        <Row justify={'space-between'} align={'middle'} style={{position:'absolute',left:25,right:25,top:0,bottom:0,zIndex:3}}
        >
            {
                stages.map(
                    (stage,index)=><div className={`circle-filled ${activeStage==stage?'glow-brighter':''} ${(stages.indexOf(activeStage)>=index)?'primary-bg':'grey-bg'}`}></div>
                )
            }
        </Row>

            <Row
                style={{position:'absolute',top:0,bottom:0,left:25,right:25}}
                align={'middle'}
            >
                {
                    stages.map((stage,index)=>index>0 && <Col flex={'auto'} className={`${(stages.indexOf(activeStage)>=index)?'primary-bg':'grey-bg'}`} style={{height:4}}></Col>)
                }
            </Row>

        </div>
    )
}

export default StageProgressBar